<!--[回迁卡密]下级代理商->自己-->
<template>
    <div class="view">
        <el-input
            v-model="keyList"
            :rows="10"
            type="textarea"
            :placeholder="lang['html.el-input.placeholder']"
            :disabled="isDisabled"
            v-loading="isLoading"
        />
        <el-tag type="info" style="margin: 10px">{{lang['html.el-tag.tips']}}</el-tag>
        <br>


        <el-popconfirm :title="lang['html.el-popconfirm.title']" @confirm="submit">
            <template #reference>
                <el-button type="primary" :disabled="isDisabled">
                    {{lang['html.el-button.submit']}}
                </el-button>
            </template>
        </el-popconfirm>

        <el-button type="warning" @click="keyList = ''" :disabled="isDisabled">{{lang['html.el-button.reset']}}</el-button>
        <el-tag style="margin-left: 10px">Keys: {{getKeyNum}}</el-tag>
    </div>
</template>

<script>
import {fromBase64} from "js-base64";

export default {
    name: "keyTackBackKey",
    data(){
        return {
            keyList:'',
            isDisabled:true,
            isLoading:true,
            lang:this.$lang.getLang('key','keyTakeBackKey')
        }
    },
    computed:{
        getKeyNum(){
            let res = this.getKeyListArr();
            if(res){
                return res.length;
            }
            return 0;
        }
    },
    methods:{
        //取过滤后的待操作卡密数组
        getKeyListArr(){
            if (this.keyList == ''){
                return null;
            }
            let arr = this.keyList.split('\n');
            let res = [];
            for (let arrKey in arr) {
                let str = arr[arrKey];
                if (str.length === 32){
                    res.push(str);
                }
            }
            return res.length === 0 ? null : res;
        },
        submit(){
            let arr = this.getKeyListArr();
            if (!arr){
                this.$alert(this.lang['submit.error.keyList']);
                return;
            }
            this.$message(this.lang['submit.wait']);
            this.isLoading = this.isDisabled = true;
            this.$api.post('Key.KeyMove/batchMoveKeyBySubordinate',{
                keyList:arr.toString(),
            }).then(res=>{
                this.isLoading = this.isDisabled = false;
                let data = this.$helper.checkRes(res);
                if(!data){
                    //调用Api失败,提示错误消息
                    let code = this.$helper.getResErrorCode(res);
                    this.$helper.alertErrMsg(this.lang,'submit.res.code.',code,);
                    return;
                }
                this.$notify(this.lang['submit.jump.wait']);
                let item = data.data;
                if (item == null){
                    this.$alert(this.lang['submit.ready.error']);
                    return;
                }
                this.$helper.jumpResultPage(item,this.lang,'submit.res.data.state.',this.lang['submit.jump.title'])
            }).catch(err=>{
                this.isLoading = this.isDisabled = false;
                this.$helper.axiosCatch(err);
            });
        }
    },
    mounted() {
        let keyList = this.$route.params.keyList;
        if (keyList){
            this.$notify('Importing data..');
            let str = fromBase64(keyList);
            this.keyList = str.replace(/,/g,"\n");
        }
        this.isDisabled = this.isLoading = false;
    }
}
</script>

<style scoped>
.view{
    width: 450px;
    margin:0 auto;
    margin-top: 20px;
}
</style>